/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PersonalRouteImport } from './routes/personal'
import { Route as PlusRouteImport } from './routes/plus'
import { Route as PointsRouteImport } from './routes/points'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as LegalIndexRouteImport } from './routes/legal.index'
import { Route as LegalKeyRouteImport } from './routes/legal.$key'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PersonalRoute = PersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => rootRouteImport,
} as any)
const PlusRoute = PlusRouteImport.update({
  id: '/plus',
  path: '/plus',
  getParentRoute: () => rootRouteImport,
} as any)
const PointsRoute = PointsRouteImport.update({
  id: '/points',
  path: '/points',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRoute = ServicesRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalIndexRoute = LegalIndexRouteImport.update({
  id: '/legal/',
  path: '/legal/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalKeyRoute = LegalKeyRouteImport.update({
  id: '/legal/$key',
  path: '/legal/$key',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/personal': typeof PersonalRoute
  '/plus': typeof PlusRoute
  '/points': typeof PointsRoute
  '/security': typeof SecurityRoute
  '/services': typeof ServicesRoute
  '/legal/$key': typeof LegalKeyRoute
  '/legal/': typeof LegalIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/personal': typeof PersonalRoute
  '/plus': typeof PlusRoute
  '/points': typeof PointsRoute
  '/security': typeof SecurityRoute
  '/services': typeof ServicesRoute
  '/legal/$key': typeof LegalKeyRoute
  '/legal': typeof LegalIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/faq': typeof FaqRoute
  '/notifications': typeof NotificationsRoute
  '/personal': typeof PersonalRoute
  '/plus': typeof PlusRoute
  '/points': typeof PointsRoute
  '/security': typeof SecurityRoute
  '/services': typeof ServicesRoute
  '/legal/$key': typeof LegalKeyRoute
  '/legal/': typeof LegalIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/faq'
    | '/notifications'
    | '/personal'
    | '/plus'
    | '/points'
    | '/security'
    | '/services'
    | '/legal/$key'
    | '/legal/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/faq'
    | '/notifications'
    | '/personal'
    | '/plus'
    | '/points'
    | '/security'
    | '/services'
    | '/legal/$key'
    | '/legal'
  id:
    | '__root__'
    | '/'
    | '/faq'
    | '/notifications'
    | '/personal'
    | '/plus'
    | '/points'
    | '/security'
    | '/services'
    | '/legal/$key'
    | '/legal/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FaqRoute: typeof FaqRoute
  NotificationsRoute: typeof NotificationsRoute
  PersonalRoute: typeof PersonalRoute
  PlusRoute: typeof PlusRoute
  PointsRoute: typeof PointsRoute
  SecurityRoute: typeof SecurityRoute
  ServicesRoute: typeof ServicesRoute
  LegalKeyRoute: typeof LegalKeyRoute
  LegalIndexRoute: typeof LegalIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/personal': {
      id: '/personal'
      path: '/personal'
      fullPath: '/personal'
      preLoaderRoute: typeof PersonalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plus': {
      id: '/plus'
      path: '/plus'
      fullPath: '/plus'
      preLoaderRoute: typeof PlusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/points': {
      id: '/points'
      path: '/points'
      fullPath: '/points'
      preLoaderRoute: typeof PointsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/': {
      id: '/legal/'
      path: '/legal'
      fullPath: '/legal/'
      preLoaderRoute: typeof LegalIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/$key': {
      id: '/legal/$key'
      path: '/legal/$key'
      fullPath: '/legal/$key'
      preLoaderRoute: typeof LegalKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FaqRoute: FaqRoute,
  NotificationsRoute: NotificationsRoute,
  PersonalRoute: PersonalRoute,
  PlusRoute: PlusRoute,
  PointsRoute: PointsRoute,
  SecurityRoute: SecurityRoute,
  ServicesRoute: ServicesRoute,
  LegalKeyRoute: LegalKeyRoute,
  LegalIndexRoute: LegalIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
